exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mention-item {\n    padding: 0.6rem 2rem;\n    border-radius: 0.25rem;\n    box-shadow: none;\n}\n.mention-selected {\n    color: #fff;\n    background: #25ce82;\n}\n", ""]);

// exports
